import dadosAgenciaComum from './dadosAgenciaComum';

export const dadosExpressoNacionalBus = {
    ...dadosAgenciaComum,
    id: 'expressonacionalbus',
    nome: 'Expresso Nacional Bus',
    instagram: 'instagram.com',
    facebook: 'facebook.com',
    youtube: 'youtube.com',
    email: 'suportevexado@gmail.com',
    idsTagManager: ['GTM-W9N2P97']
};
